import { sanitizeVercelProjectName } from '../project/sanitize-vercel-project-name.js'

export function blobStoreName(projectName: string): string {
  return sanitizeVercelProjectName(`${projectName}-blob`)
}
